import React from "react";
import { Link } from "react-router-dom";
import arianaImage from "../../images/iserenify/iserenify_ariana_image_circle.JPEG";
import AdminImageZoom from "../AdminImageZoom";
import MainPageTextEditor, {
  FormattedMainPageText,
  useMainPageText,
} from "../MainPageTextEditor";
import "./style.css";

const DEFAULT_TEXT = {
  paragraphOne:
    "Mai mult decât o simplă consultanță — o experiență senzorială creată pentru starea ta de bine.",
  paragraphTwo:
    "Testează și descoperă uleiurile esențiale potrivite nevoilor tale emoționale și fizice și învață cum să aduci mai mult calm, energie și echilibru în viața ta de zi cu zi.",
  paragraphThree:
    "Programează o ședință gratuită și începe propria experiență de transformare — online sau fizic.",
};

const TEXT_FIELDS = [
  { key: "paragraphOne", label: "Paragraf 1" },
  { key: "paragraphTwo", label: "Paragraf 2", rows: 4 },
  { key: "paragraphThree", label: "Paragraf 3" },
];

const BloomCoaching = () => {
  const [content, setContent] = useMainPageText("coaching", DEFAULT_TEXT);

  return (
    <section className="new-coaching main-page-text-editable">
      <MainPageTextEditor
        section="coaching"
        sectionLabel="Coaching"
        fields={TEXT_FIELDS}
        value={content}
        onSaved={setContent}
      />
      <div className="new-coaching__inner">
        <div className="new-coaching__card">
          <div className="new-coaching__header">
            <span className="new-coaching__pre-title">
              VINO SĂ NE CUNOAȘTEM
            </span>
            <h2 className="new-coaching__title">Coaching 1 la 1</h2>
            <p className="new-coaching__subtitle">experiență personalizată</p>
          </div>

          <div className="new-coaching__content">
            <AdminImageZoom
              settingKey="coachingImageScale"
              imageKey="coachingImage"
              src={arianaImage}
              alt="Coaching"
              frameClassName="new-coaching__image-wrap"
            />
            <div className="new-coaching__text-wrap">
              <p className="new-coaching__text">
                <FormattedMainPageText text={content.paragraphOne} />
              </p>
              <p className="new-coaching__text">
                <FormattedMainPageText text={content.paragraphTwo} />
              </p>
              <p className="new-coaching__text">
                <FormattedMainPageText text={content.paragraphThree} />
              </p>
              <Link to="/consultanta" className="new-coaching__btn">
                Programează o sesiune
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BloomCoaching;
